<template><zen-one
    :showuserinfo="false"
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

  <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">

            <z-page title="Daftar : Kewangan 38">

                    <div class="message-box">
                    <w-transition-fade>
                        <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border>
                        The form is valid, ready to send it!
                        </w-alert>

                        <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border>
                        Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                        </w-alert>
                    </w-transition-fade>
                    </div>

                    <w-flex class="mt3">
                        <div class="xs4 mr3">
                            <w-input
                            required
                            placeholder="Sila Masukan Tarikh Bayaran"
                            label="Tarikh Bayaran"
                            type="date"
                            v-model="tarikh_bayar"
                            :validators="[validators.required]">
                            </w-input>
                        </div>
                        <div class="xs4 mr3">
                            <z-lookup
                            required
                            placeholder="Sila Masukkan Cara Bayaran"
                            label="Cara Bayaran"
                            :url='service_utiliti+"lookup/cara_bayar"'
                            v-model="lkp_cara_bayaran_id"
                            :sort="false" :cache="false"
                            :validators="[validators.required]"/>
                        </div>
                        <div class="xs4 mr3">
                            <w-input
                            required
                            placeholder="Sila Masukan Penyata Pemungut"
                            label="No. Penyata Pemungut"
                            v-model="no_penyata_pemungut">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-input
                            required
                            placeholder="Sila Masukan No. Rujukan Bank"
                            label="No. Rujukan Bank"
                            v-model="no_slip_bank">
                            </w-input>
                        </div>
                    </w-flex>
            </z-page>

        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitKew38" @success="onSuccess">
            <z-page title="Butiran Bayaran" >
                  <w-card bg-color="" class="">
                    <w-flex justify-space-between class="mb4">
                        <div class="xs12">
                            <w-input
                            v-model="form_cari.no_rujukan"
                            placeholder="Sila Masukkan No Rujukan"
                            name="no_rujukan"/>
                        </div>
                        <div class="xs1">
                            <w-button class="ml1 " @click="Detail()">
                                <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </div>
                    </w-flex>
                  </w-card>
                  <w-flex justify-center align-center class="table-hardcode mt3">
                     <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Jabatan</td>
                                    <td>No. Rujukan</td>
                                    <td>Nama</td>
                                    <td>Kod Akaun</td>
                                    <td>Butiran Bayaran</td>
                                    <td>Amaun (RM)</td>
                                    <td>Amaun Bayar (RM)</td>
                                    <td>No Resit Kew. 38</td>
                                    <td>Catatan</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="dat, index in form.hm_cukai">
                                    <td>
                                      {{dat.jabatan}}
                                    </td>
                                    <td>
                                      {{dat.no_hm}}
                                    </td>
                                    <td>
                                      {{dat.profil_nama}}
                                    </td>
                                    <td>
                                      {{dat.kod_akaun}}
                                    </td>
                                    <td>
                                      {{dat.akaun_keterangan}}
                                    </td>
                                    <td>
                                      {{dat.amaun_debit}}
                                    </td>
                                    <td>
                                        <w-input class="mb4" label="" type="number" v-model="dat.amaun_bayar"/>
                                    </td>
                                    <td>
                                        <w-input class="mb4" label="" v-model="dat.resit_kew38"/>
                                    </td>
                                    <td>
                                        <w-input class="mb4" label="" v-model="dat.catatan"/>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <div class="spacer" />
                            <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                                <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                            </w-button>
                        </w-flex>
                      </div>
                  </w-flex>
            </z-page>
        </w-form>

      </w-form>

  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
components: {
  extends: ZResource

},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'doughnut',
      data: {

        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [40, 20, 80, 10]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {

  resourceurl: this.service_kutipan+'terimaan',
  form_cari : {},
  dialog: {
        show: false,
        show2: false,
        fullscreen: false,
        persistent: false,
        persistentNoAnimation: false,
        width: 500
  },
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Kewangan 38', route: '/mel' },
        { label: 'Daftar', route: '/kutipan/mel/daftar' },
  ],
  showCard: false,
}},
methods: {

  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    this.$inertia.visit(window.route('kutipan.kew38.index'));

  },

  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  },

  Detail() {
    this.$zcomm.get(this.service_kutipan+'terimaan'+'?no_rujukan='+this.form_cari.no_rujukan).then(res => {
    //   console.log(res.data)
        if (res.data.butiran) {
            this.form.inbois_id = res.data.id;
            this.form.butiran = res.data.butiran;
            this.form.amaun = res.data.amaun;
            this.form.no_inbois = res.data.no_inbois;
            this.form.jabatan_id = res.data.jabatan.id;
        }else{
            this.form.hm_akaun_id = res.data.id;
            this.form.hm_cukai = res.data.hm_cukai;
            this.form.keluasan = res.data.keluasan;
            this.form.no_hm = res.data.no_hm;
            this.form.jabatan_id = res.data.jabatan.id;
        }
    });
  },

  submitKew38(){
    this.form.tarikh_bayar = this.tarikh_bayar
    this.form.lkp_cara_bayaran_id = this.lkp_cara_bayaran_id
    this.form.no_penyata_pemungut = this.no_penyata_pemungut
    this.form.no_slip_bank = this.no_slip_bank
    this.$zcomm.post(this.service_kutipan+'kutipan/kew38', this.form)
        .then(res => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                        }

                    })
                    .catch(err => {

                    })
                    .finally(() => {
                            this.$inertia.visit(window.route('kutipan.kew38.index'));
                    })
                    ;
    },


 }
}

</script>

<style>


</style>
